import { isPair } from './pairedCards'

function getBestCard(sourceCard, computerHand, playerHand, handOver) {
  let bestCard
  bestCard = computerHand.find(card => {
    return card.value === 25 && card.displayClass === 'visible'
  })

  if (bestCard) {
    return bestCard
  }

  bestCard = computerHand.find(card => {
    return card.value === 15 && card.displayClass === 'visible'
  })

  if (bestCard) {
    return bestCard
  }

  if (handOver) {
    const cards = computerHand.filter(card => {
      return (card.displayClass = 'visible' && card.value > sourceCard.value)
    })
    const sortedCards = cards.sort((a, b) => {
      return b.value - a.value
    })
    if (sortedCards.length > 0) {
      if (sourceCard.value < sortedCards[0]) {
        bestCard = sortedCards[0]
      }
      return bestCard ? bestCard : ''
    }
    return
  }

  const hiddenCards = computerHand.filter(card => {
    return card.displayClass === 'hidden'
  })

  const visibleCards = computerHand.filter(card => {
    return card.displayClass === 'visible'
  })

  if (hiddenCards.length > 1) {
    return randomizeHiddenCards(hiddenCards)
  }

  if (visibleCards.length > 1) {
    const sortedCards = visibleCards.sort((a, b) => {
      return b.value - a.value
    })
    if (sortedCards.length > 1) {
      let i = 0
      while (i < sortedCards.length) {
        let card = sortedCards[i]
        if (!isPair(card, computerHand)) {
          if (!isPair(card, playerHand)) {
            if (sourceCard.value < card.value) {
              i = sortedCards.length
              return card
            }
          }
        }
        i++
      }
    }
  } else {
    const checkCard = visibleCards[0]
    if (!isPair(checkCard, computerHand)) {
      if (!isPair(checkCard, playerHand)) {
        if (sourceCard.value < checkCard.value) {
          return checkCard
        }
      }
    }
  }
  return
}

function randomizeHiddenCards(hidden) {
  for (let i = hidden.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i)
    const temp = hidden[i]
    hidden[i] = hidden[j]
    hidden[j] = temp
  }
  return hidden[0]
}

export { getBestCard }
